import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import ProfileTab from './profile/ProfileTab'
import SecurityTab from './security/SecurityTab'
import * as Help from 'modules/app/Help'

class Profile extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			activeTab: this.props.location.hash
		};
	}

	handleTabSelect = (key) => {
		this.setState({
			activeTab: key
		})

	}

	render() {
		const tabs = [
			{ key: "#ProfileTab", title: "Profile", comp: ProfileTab, helpKey: Help.userProfileInfoHelpKey },
			{ key: "#SecurityTab", title: "Security", comp: SecurityTab, helpKey: Help.userProfileSecurityHelpKey }
		];
		
		let profileTabs = tabs.map(tab => {
			const Comp = tab.comp;

			return (
				<Tab key={tab.key} eventKey={tab.key} title={tab.title}>
					<div className='tab-pane'>
						<div className='panel-body'>
							{this.state.activeTab === tab.key &&
								<Comp tabKey={tab.key}
									helpKey={tab.helpKey} />
							}
						</div>
					</div>
				</Tab>
			);
		});

		return (
			<div>
				<ContentHeader title="My Profile" />
				<ContentBody>
					<Tabs id="dashboardTabs" className="tabs-container" onSelect={this.handleTabSelect} defaultActiveKey={this.state.activeTab}>
						{profileTabs}
					</Tabs>
				</ContentBody>
			</div>
		);
	}
}

export default Profile;



// WEBPACK FOOTER //
// ./src/areas/main/profile/Profile.js